import { useState, useEffect } from "react";
import {ApiUrl} from "../../ApiUrl"

// Custom hook to fetch the list of classes
const useClasses = () => {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchClasses = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${ApiUrl.apiurl}Class/GetAllClass/`);
        if (!response.ok) {
          throw new Error("Failed to fetch classes");
        }
        const result = await response.json();
        setClasses(Array.isArray(result?.data) ? result.data : []);
      } catch (err) {
        setError("Failed to load classes.");
        setClasses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchClasses();
  }, []);

  return { classes, loading, error };
};

export default useClasses;
